import { type ReactNode, useState } from 'react';

interface Tab {
  key: string;
  label: string;
  content: ReactNode;
}

interface TabsProps {
  tabs: Tab[];
  defaultTab?: string;
  activeTab?: string;
  onTabChange?: (key: string) => void;
}

export function Tabs({ tabs, defaultTab, activeTab, onTabChange }: TabsProps) {
  const [internalKey, setInternalKey] = useState(defaultTab || tabs[0]?.key || '');
  const activeKey = activeTab ?? internalKey;

  function handleChange(key: string) {
    setInternalKey(key);
    onTabChange?.(key);
  }

  const currentTab = tabs.find((t) => t.key === activeKey);

  return (
    <div>
      <div className="flex border-b border-border mb-4">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => handleChange(tab.key)}
            className={`px-4 py-2.5 text-sm font-medium transition-colors border-b-2 -mb-px ${
              activeKey === tab.key
                ? 'text-primary border-primary'
                : 'text-text-muted border-transparent hover:text-text-secondary'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
      {currentTab?.content}
    </div>
  );
}
